import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CommodityManagementSiteAccessModel} from '../../Generated/Commodity-Management-Api';
import { CompanyProductAccessEntryModel, GetTermsAndConditionsResponse, MarketViewApplication } from '../../Generated/Mark-It-View-Api';

export interface UserAccessState {
  email?: string;
  displayName?: string;
  companyGuid?: string;
  companyName?: string;
  commodityManagementUserSiteAccesses: CommodityManagementSiteAccessModel[];
  marketViewApplications: MarketViewApplication[];
  productAccess: CompanyProductAccessEntryModel[];
  hasAccess: boolean;
  isAdmin: boolean;
  agreedToTermsAndConditions?: boolean;
  isEmployee: boolean;
  isDisabled?: boolean;
}

interface SetUserAccessPayload {
  email?: string;
  displayName?: string;
  companyGuid?: string | null;
  companyName?: string | null;
  commodityManagementUserSiteAccesses: CommodityManagementSiteAccessModel[] | undefined | null;
  marketViewApplications: MarketViewApplication[] | undefined | null;
  productAccess: CompanyProductAccessEntryModel[] | undefined | null;
  hasAccess: boolean | undefined | null;
  isAdmin: boolean | undefined | null;
  agreedToTermsAndConditions?: boolean;
  isEmployee: boolean;
  isDisabled?: boolean;
}

const initialState: UserAccessState = {
  email: undefined,
  displayName: undefined,
  companyGuid: undefined,
  companyName: undefined,
  commodityManagementUserSiteAccesses: [],
  marketViewApplications: [],
  productAccess: [],
  hasAccess : false,
  isAdmin: false,
  agreedToTermsAndConditions: false,
  isEmployee: false,
  isDisabled: false 
};

export const userAccessSlice = createSlice({
  name: 'userAccess',
  initialState,
  reducers: {
    setUserAccess: (state: UserAccessState, { payload }: PayloadAction<SetUserAccessPayload>): void => {
      state.email = payload.email;
      state.displayName = payload.displayName;
      state.companyGuid = payload.companyGuid ?? undefined;
      state.companyName = payload.companyName ?? undefined;
      state.commodityManagementUserSiteAccesses = payload.commodityManagementUserSiteAccesses ?? [];
      state.marketViewApplications = payload.marketViewApplications ?? [];
      state.productAccess = payload.productAccess ?? [];
      state.hasAccess = payload.hasAccess ?? false;
      state.isAdmin = payload.isAdmin ?? false;
      state.agreedToTermsAndConditions = payload.agreedToTermsAndConditions;
      state.isEmployee = payload.isEmployee ?? false;
      state.isDisabled = payload.isDisabled ?? false;
    },
    resetUserAccess: (state: UserAccessState) => {
      state.email = undefined;
      state.displayName = undefined;
      state.companyGuid = undefined;
      state.companyName = undefined;
      state.commodityManagementUserSiteAccesses = [];
      state.marketViewApplications = [];
      state.productAccess = [];
      state.hasAccess = false;
      state.isAdmin = false;
      state.agreedToTermsAndConditions = undefined;
      state.isDisabled = false;
    }
  }
});

export const { setUserAccess, resetUserAccess } = userAccessSlice.actions;
export default userAccessSlice.reducer;